import { useScopeParams } from "@/hooks/useScopeParams";
import { PageTemplate } from "@/components/Templates/PageTemplate";

export default function ImagingReads() {
  const { id } = useScopeParams();

  return (
    <PageTemplate
      title="Measures: Imaging Reads"
      tooltipText="Explore independent-review read units per subject: timepoint, question set, workflow status, and read completion times."
      type="imaging_read_units"
      constants={{
        wikiLink: "/wiki/guides/exploration-measures-imagingreads",
        idLink: (subjectId: string) =>
          `/${id}/subjects/overview/${subjectId}/imaging`,
      }}
    />
  );
}
